import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import LinkDAO, {Link} from 'link-preview/LinkDAO';

const syncLinks = (added: Array<string>, removed: Array<string>): void => {
  if (added.length + removed.length === 0) {
    return;
  }
  AppDispatcher.dispatch({
    actionType: EventConstants.LINK_SYNC,
    added,
    removed,
  });
};

const fetchPreviews = (urls: Array<string>): void => {
  LinkDAO.fetchPreviews(urls).done((response: {data: Array<Link>}) => {
    AppDispatcher.dispatch({
      actionType: EventConstants.LINK_PREVIEWS_FETCHED,
      previews: response.data,
    });
  });
};

const LinkActions = {syncLinks, fetchPreviews};

export default LinkActions;
